<script>
    import { afterUpdate, getContext } from "svelte";
    import { key } from "./mapbox.js";
    import { arrayFromCoordinateDirctionary } from "../../../helpers/geo.js";

    export let route = [];
    export let name;
    export let color = "orangered";
    export let opacity = 0.75;

    const map = getContext(key).map();

    let isStyleLoaded = map && map.isStyleLoaded();

    function render() {
        if (map.getSource(name) === undefined) {
            map.addSource(name, {
                type: "geojson",
                tolerance: 3.0,
                data: {
                    type: "Feature",
                    properties: {},
                    geometry: {
                        type: "LineString",
                        coordinates: route.map(arrayFromCoordinateDirctionary)
                    }
                }
            });
        } else {
            map.getSource(name).setData({
                type: "Feature",
                properties: {},
                geometry: {
                    type: "LineString",
                    coordinates: route.map(arrayFromCoordinateDirctionary)
                }
            });
        }

        if (map.getLayer(name) === undefined) {
            map.addLayer({
                id: name,
                type: "line",
                source: name,
                layout: {
                    "line-join": "round",
                    "line-cap": "round"
                },
                paint: {
                    "line-color": color,
                    "line-width": 4,
                    "line-opacity": opacity
                }
            });
        }
    }

    $: route && map && isStyleLoaded && render();

    if (isStyleLoaded) {
        render();
    } else {
        map.on("load", render);
    }

    afterUpdate(() => {
        if (isStyleLoaded) {
            render();
        }
    });

    map.once("style.load", () => {
        isStyleLoaded = true;
    });
</script>
